import { render, staticRenderFns } from "./UploadsSectionSearch.vue?vue&type=template&id=c0f1d8a8&scoped=true&"
import script from "./UploadsSectionSearch.vue?vue&type=script&lang=js&"
export * from "./UploadsSectionSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f1d8a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
